
'use client'

import { URLConstants } from "@/constants/URLConstants";
import { useNotifyGetNewPostedImage } from "@/hooks/notification/useNotification";
import { NOTIFICATION_TYPE_VALUE } from "@/restapi/notification";
import { useSession } from "next-auth/react";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

interface HomeActiveIconProps {
	color?: string;
	notificationCount?: number;
}


const HomeActiveIcon: React.FC<HomeActiveIconProps> = ({
	color = "#fff",
}) => {
	const [count, setCount] = useState(0);
	const { data: session } = useSession();
	const user = session?.user;
	const userId = user?.id ?? "";
	const { item } = useNotifyGetNewPostedImage({
		notificationType: NOTIFICATION_TYPE_VALUE.NEW_POSTED_IMAGE,
		userId,
		groupId: null,
	});



	useEffect(() => {
		if (item) {
			setCount(item?.count ?? 0);
		}
	}, [item]);
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 105 100">
			<defs>
				<style>
					{`
            .cls-1 { fill: none; }
            .cls-1, .cls-2 { stroke-width: 0px; }
            .cls-2 { fill: #fff; }
          `}
				</style>
			</defs>
			<path className="cls-2" d="M48.177.617L1.177,37.351c-.742.568-1.177,1.449-1.177,2.383v58.766c0,.828.672,1.5,1.5,1.5h32c.828,0,1.5-.672,1.5-1.5v-35.661c0-.828.672-1.5,1.5-1.5h27c.828,0,1.5.672,1.5,1.5v35.661c0,.828.672,1.5,1.5,1.5h32c.828,0,1.5-.672,1.5-1.5v-58.766c0-.934-.435-1.815-1.177-2.383L51.823.617c-1.076-.823-2.57-.823-3.646,0Z" />
			<rect className="cls-1" />
			{count > 0 && (
				<g transform="translate(63, 63)">
					<circle cx="20" cy="20" r="20" fill="red" />
					<text x="20" y="27" fontSize="20" fill="white" textAnchor="middle">
						{count > 99 ? 99 : count}
					</text>
				</g>
			)}
		</svg>
	);
}

export default HomeActiveIcon;